
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[slug]",
      function () {
        return require("private-next-pages/blog/page/[slug].tsx");
      }
    ]);
  